var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo.webp"),"alt":"logo"}}),_c('img',{attrs:{"src":require("@/assets/mindfood-light.png"),"alt":"mindfood"}})])
}]

export { render, staticRenderFns }